module.exports = __webpack_public_path__ + "assets/img/user-icon_zt.d7d14ea7.svg";